const styles = theme => ({
  dialogPaper: {
    width: '600px',
    maxWidth: '100%',
    borderRadius: '16px',
    padding: '0px',
  },
  dialogTitle: {
    padding: '24px 24px 0 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialogContent: {
    padding: '0 24px 24px 24px',
  },
  closeButton: {
    cursor: 'pointer',
    color: '#637381',
  },
  tabs: {
    borderBottom: '1px solid #E0E0E0',
    padding: '0 24px',
    marginTop: '16px',
    '& .MuiTabs-indicator': {
      backgroundColor: '#015FFB', // Official Blue
      height: '3px',
    },
  },
  tab: {
    textTransform: 'none',
    minWidth: 'auto',
    fontWeight: 500,
    fontSize: '14px',
    color: '#637381',
    marginRight: '24px',
    '&.Mui-selected': {
      color: '#015FFB',
      fontWeight: 600,
    },
  },
  tabLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  soonLabel: {
    fontSize: '10px',
    backgroundColor: '#F4F6F8',
    color: '#637381',
    padding: '2px 6px',
    borderRadius: '4px',
    fontWeight: 600,
  },
  tabPanel: {
    paddingtop: '24px',
  },
  uploadContainer: {
    border: '1px dashed #919EAB',
    borderRadius: '12px',
    height: '240px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FATBFC', // Light background
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
  },
  uploadIcon: {
    fontSize: '48px',
    color: '#015FFB',
    marginBottom: '16px',
  },
  uploadTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#212B36',
    marginBottom: '8px',
  },
  uploadSubtitle: {
    fontSize: '14px',
    color: '#637381',
    textAlign: 'center',
    maxWidth: '250px',
  },
  videoInputContainer: {
    marginBottom: '24px',
  },
  videoInput: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#F9FAFB',
    '& input': {
      border: 'none',
      outline: 'none',
      width: '100%',
      backgroundColor: 'transparent',
      fontSize: '14px',
      color: '#212B36',
    },
  },
  addVideoButton: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor: '#015FFB', // Official Blue
    color: '#fff',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#0B4EBA',
    },
  },
  youtubeUpgradeBanner: {
    display: 'flex',
    borderRadius: '16px',
    overflow: 'hidden',
    border: '1px solid #E0E0E0',
    position: 'relative',
    minHeight: '240px',
  },
  youtubeUpgradeBannerLeft: {
    width: '50%',
    padding: '32px 24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
    backgroundColor: '#fff',
    position: 'relative',
    zIndex: 1,
  },
  youtubeUpgradeBannerTitle: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#002E47',
    lineHeight: '150%',
  },
  youtubeUpgradeBannerDesc: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#637381',
    lineHeight: '150%',
  },
  youtubeUpgradeBannerButton: {
    padding: '10px 24px',
    borderRadius: '8px',
    backgroundColor: '#015FFB',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': {
      backgroundColor: '#0B4EBA',
    },
  },
  youtubeUpgradeBannerRight: {
    width: '478px',
    height: '478px',
    borderRadius: '50%',
    background: 'linear-gradient(129deg, #6FB6FE 4.25%, #015FFB 108.32%)',
    position: 'absolute',
    right: '-203px',
    top: '50%',
    transform: 'translateY(-50%)',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  youtubeUpgradeBannerImage: {
    position: 'absolute',
    left: '17px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '246px',
    height: 'auto',
  },
})

export default styles
